/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_TitleInputs */

const id_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul`)
};

const ms_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk`)
};

const da_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const de_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const en_us2_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_es2_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const es_mx2_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const fil_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamagat`)
};

const fr_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

const it_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo`)
};

const hu_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cím`)
};

const nl_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const no_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittel`)
};

const pl_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł`)
};

const pt_br2_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const pt_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const ro_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlu`)
};

const fi_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikko`)
};

const sv_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const vi_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề`)
};

const tr_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık`)
};

const cs_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const bg_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавие`)
};

const ru_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок`)
};

const uk_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок`)
};

const ar_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان`)
};

const hi_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक`)
};

const th_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อเรื่อง`)
};

const ja_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const zh_cn2_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const zh_hant1_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const ko_forms_review_title = /** @type {(inputs: Forms_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Forms_Review_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_title = /** @type {((inputs?: Forms_Review_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_title(inputs)
	if (locale === "ms") return ms_forms_review_title(inputs)
	if (locale === "da") return da_forms_review_title(inputs)
	if (locale === "de") return de_forms_review_title(inputs)
	if (locale === "en-US") return en_us2_forms_review_title(inputs)
	if (locale === "es-ES") return es_es2_forms_review_title(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_title(inputs)
	if (locale === "fil") return fil_forms_review_title(inputs)
	if (locale === "fr") return fr_forms_review_title(inputs)
	if (locale === "it") return it_forms_review_title(inputs)
	if (locale === "hu") return hu_forms_review_title(inputs)
	if (locale === "nl") return nl_forms_review_title(inputs)
	if (locale === "no") return no_forms_review_title(inputs)
	if (locale === "pl") return pl_forms_review_title(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_title(inputs)
	if (locale === "pt") return pt_forms_review_title(inputs)
	if (locale === "ro") return ro_forms_review_title(inputs)
	if (locale === "fi") return fi_forms_review_title(inputs)
	if (locale === "sv") return sv_forms_review_title(inputs)
	if (locale === "vi") return vi_forms_review_title(inputs)
	if (locale === "tr") return tr_forms_review_title(inputs)
	if (locale === "cs") return cs_forms_review_title(inputs)
	if (locale === "bg") return bg_forms_review_title(inputs)
	if (locale === "ru") return ru_forms_review_title(inputs)
	if (locale === "uk") return uk_forms_review_title(inputs)
	if (locale === "ar") return ar_forms_review_title(inputs)
	if (locale === "hi") return hi_forms_review_title(inputs)
	if (locale === "th") return th_forms_review_title(inputs)
	if (locale === "ja") return ja_forms_review_title(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_title(inputs)
	return ko_forms_review_title(inputs)
});
export { forms_review_title as "forms.review.title" }